import React, { useEffect, useRef, useState } from 'react'
import { useQuery, QueryClient, QueryClientProvider } from 'react-query'
import ReactDOM from 'react-dom'
import AskPriceModalMenu from '@Components/campaigns/2021/AskPriceModalMenu'
import '@Styles/global.less'
import styles from './index.module.less'
import Cookie from 'js-cookie'

const queryClient = new QueryClient()

const Trial: React.FC = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    let flag = Cookie.get('isArticleInquiry');
    flag && flag === '1' && setVisible(false);
  }, [])

  return (
    <section className={styles['']}>
      <AskPriceModalMenu visible={visible} setVisible={setVisible} />
    </section>
  )
}

const $trialPage = document.getElementById("acticle-campagin-inquiry")
if (!!$trialPage) {
  ReactDOM.render(
    <QueryClientProvider client={queryClient}><Trial /></QueryClientProvider>,
    $trialPage,
  );
}
